import * as React from 'react';

export interface SidebarNextProps {
  dataHook?: string;
  className?: string;
  children?: React.ReactNode;
  skin?: 'dark' | 'light' | 'neutral';
  header?: React.ReactNode;
  footer?: React.ReactNode;
  hidden?: boolean;
  selectedKey?: string;
  isLoading?: boolean;
  ariaLabel?: string;
  width?: string | number;
  minimized?: boolean;
  enableMinimizeToggle?: boolean;
  minimizeToggleTooltip?: string;
  onMinimizeToggleClick?: () => void;
  zIndex?: number;
}

export default class SidebarNext extends React.PureComponent<SidebarNextProps> {}
